import axios from "axios";
import API_BASE_URL from "../config";

export const fetchTransactionSummary = async (username, filterUser,start, end) => {
  const res = await axios.get(`${API_BASE_URL}/transactions/summary`, {
     headers: {
              'X-Frontend-Request': 'true',
         
        },
    params: { username: username, filterUser: filterUser,start: start, end:end },
  });
  return res.data;
};